export type ObservatoryRoute =
  | { name: "landing" }
  | { name: "radar" }
  | { name: "skills-match" }
  | { name: "methodology" }
  | { name: "my-results" }
  | { name: "unknown"; path: string };

export function getBasePath(): string {
  const cfg = window.BOOSTSCIENCE_OBSERVATORY;
  if (cfg?.basePath) return cfg.basePath.replace(/\/$/, "");
  return "";
}

export function currentPath(): string {
  const base = getBasePath();
  let path = window.location.pathname;
  if (base && (path === base || path.startsWith(`${base}/`))) {
    path = path.slice(base.length) || "/";
  }
  return path.replace(/\/+$/, "") || "/";
}

export function parseRoute(path = currentPath()): ObservatoryRoute {
  if (path === "/" || path === "") return { name: "landing" };
  if (path === "/radar") return { name: "radar" };
  if (path === "/skills-match") return { name: "skills-match" };
  if (path === "/methodology") return { name: "methodology" };
  if (path === "/my-results") return { name: "my-results" };
  return { name: "unknown", path };
}

export function hrefFor(route: string, search = ""): string {
  const base = getBasePath();
  const path = route.startsWith("/") ? route : `/${route}`;
  return `${base}${path}${search}`;
}

export function navigate(route: string, search = "", replace = false): void {
  const url = hrefFor(route, search);
  if (replace) window.history.replaceState({}, "", url);
  else window.history.pushState({}, "", url);
  window.dispatchEvent(new Event("bs-observatory-navigate"));
}

export function searchString(): string {
  return window.location.search;
}
